import { __decorate, __metadata, __param } from "tslib";
import { injectable, optional } from "inversify";
import { LocalizationOptionsProvider } from "./LocalizationOptionsProvider";
import { LocalizationOptionsStore } from "./LocalizationOptions";
let LocalizationOptionsService = class LocalizationOptionsService {
    constructor(store, provider) {
        this.store = store;
        this.provider = provider;
    }
    async initializeOptions() {
        if (!this.provider)
            return;
        const options = await this.provider.getOptions();
        this.store.set(options);
    }
};
LocalizationOptionsService = __decorate([
    injectable(),
    __param(1, optional()),
    __metadata("design:paramtypes", [LocalizationOptionsStore,
        LocalizationOptionsProvider])
], LocalizationOptionsService);
export { LocalizationOptionsService };
//# sourceMappingURL=LocalizationOptionsService.js.map